import { useState } from "react";

const platforms = [
  { label: "微信", icon: "ri-wechat-2-fill" },
  { label: "抖音", icon: "ri-arrow-up-line" },
  { label: "小红书", icon: "ri-bubble-chart-line" },
];

export default function TopStrip() {
  const [live, setLive] = useState(true);

  return (
    <section className="bg-foreground-950 text-background-100">
      <div className="mx-auto flex max-w-[1240px] flex-col gap-3 px-4 py-3 md:px-6 lg:flex-row lg:items-center lg:justify-between">
        <div className="flex min-w-0 items-center gap-3">
          <span
            onClick={() => setLive((v) => !v)}
            className={`flex h-2.5 w-2.5 shrink-0 items-center justify-center rounded-full ${live ? "bg-primary-400" : "bg-background-600"}`}
          >
            {live && <span className="h-2.5 w-2.5 animate-ping rounded-full bg-primary-400 opacity-70" />}
          </span>
          <p className="truncate text-xs leading-relaxed text-background-100/90 md:text-sm">
            <span className="font-medium text-background-50">今日更新 · 2026.09.06</span>
            <span className="mx-2 text-background-100/50">|</span>
            解约风波来龙去脉全文已上线，内幕细节第 3 处补充完毕
          </p>
        </div>

        <div className="flex shrink-0 flex-wrap items-center gap-2">
          <span className="hidden text-xs text-background-100/60 md:inline">全端入口</span>
          {platforms.map((p) => (
            <button
              key={p.label}
              type="button"
              className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-background-100/10 px-3 py-1.5 text-xs text-background-100 transition hover:bg-background-100/20"
            >
              <i className={`${p.icon} h-3 w-3`} />
              {p.label}
            </button>
          ))}
          <a
            href="#gengduo"
            className="inline-flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500 px-3.5 py-1.5 text-xs font-medium text-background-50 transition hover:bg-primary-600"
          >
            <i className="ri-download-2-line h-3 w-3" />
            下载 App
          </a>
        </div>
      </div>
    </section>
  );
}